const tableTitle = {
  buyVol: 'KL MUA',
  bid: 'GIÁ MUA',
  ask: 'GIÁ BÁN',
  sellVol: 'KL BÁN',
  unmatchedBuyVol: 'TỔNG KL MUA',
  unmatchedSellVol: 'TỔNG KL BÁN',
  totalMatchedVol: 'TỔNG KL KHỚP',
};

const relatedInformations = {
  bid: 'Giá Mua',
  ask: 'Giá Bán',
  frBuyVol: 'KLNN Mua',
  frSellVol: 'KLNN Bán',
  volume: 'Khối Lượng',
  avgPrice: 'Giá TB',
  avgVol1m: 'KLGDTB 1M',
  avgVol10d: 'KLGDTB 10D',
  pe: 'P/E',
  beta: 'Beta',
  eps: 'EPS',
  pb: 'P/B',
  marketCap: 'Vốn Hóa (Tỷ)',
  foreignOwner: '% SHNN',
  ranking: 'Xếp Hạng',
  roe: 'ROE',
};

const action = {
  lvl1: '3 bước giá',
  lvl2: '10 bước giá',
  upgrade: 'Nâng Cấp',
  upgradeTitle: 'Nâng Cấp Lên Tài Khoản Premium Để Mở Khóa Chức Năng',
};

const groupButton = {
  buy: 'MUA',
  sell: 'BÁN',
};

export default {
  groupButton,
  tableTitle,
  relatedInformations,
  action,
};
